import createAction from 'modules/conference/actions';
import { isGalleryEnabled } from 'modules/appointmentInfo/selectors/mediaGallery';

export const CHANGE_PATIENT_INFO_TAB = createAction('CHANGE_PATIENT_INFO_TAB');


export const changePatientInfoTab = (tabId) => (dispatch) => {
  dispatch({
    type: CHANGE_PATIENT_INFO_TAB,
    meta: { tabId },
  });
};

export const openMediaGalleryTab = () => (dispatch, getState) => {
  const galleryEnabled = isGalleryEnabled(getState());
  if (galleryEnabled) dispatch(changePatientInfoTab('3'));
};
